<section class="popular-vechicle-sec pt-5 pb-5">
  <div class="container-fluid productlist">
      <div class="content-heading mb-4" *ngIf="popularVehicleList?.length>0">
          <h1 class="page-sub-title cv-text-dark"> Latest Used Vehicles List</h1>
      </div>
      <owl-carousel-o [options]="customOptions3">
          <ng-container *ngFor="let element of popularVehicleList">
            <ng-template carouselSlide>
              <div class="col-lg-3 col-md-4 col-sm-12 carddiv">
                  <div class="card" *ngIf="popularVehicleList?.length>0">
                        <img [src]="getiscover(element?.vehicle_documents)" (click)="redirect(element.id)" class="card-img-top mainimg" alt="Vehicle Image">
                      <div class="d-flex align-items-center tagf">
                            <span class="badge bg-primary"><img class="eye" [src]='environment1 + "assets/images/eye.png"' alt=""> {{element?.view_count}} Views </span>
                          <div class="like ms-auto d-none">
                            <button style="width: 24px; height: 24px; border: none;background-color: transparent;">
                              <span >
                                <img style="width: 24px; height: 24px;" [src]="environment1 + 'images/new-images/heart.svg'" alt="heart" loading="lazy">
                              </span>
                            </button>
                          </div>
                        </div>
                        <div *ngIf="element.vehicle_certificate_type == 'Certified'">
                            <img class="tataoklogobottom" [src]='environment1 + "assets/images/tata-ok.png"' alt="">
                          <span class="text-white tataoklogobottomspan">Refurbished</span>
                        </div>
                      <div class="card-body">
                        <div class="card-title text-ellipsis">
                          <a  [title]="element?.model">{{element.model}}</a></div>
                          <div class="card-data">
                          <div class="d-flex col-12 text-left d1 aligndiv">
                              <p class="col-4">State</p>
                              <p class="col-4">District</p>
                              <p class="col-4">Fuel Type</p>
                          </div>
                          <div class="d-flex col-12 d2 text-left aligndiv d3">
                            <p class="col-4 district">{{element?.state}}</p>
                            <p class="col-4 district">{{element?.district ? (element?.district  | titlecase) : ''}}</p>
                            <p class="col-4">{{element?.fuel_type ? element?.fuel_type : '-'}}</p>
                          </div>
                          <div class="d-flex col-12 text-left d1 aligndiv mt-2">
                              <p class="col-4">KMs</p>
                              <p class="col-4">Owner</p>
                              <p class="col-4">Year</p>
                          </div>
                          <div class="d-flex col-12 d2 text-left aligndiv">
                            <p class="col-4">{{element.odometer ? (element.odometer |  number:'1.0-0') : ''}}</p>
                            <p class="col-4">{{getFirstPartOfOwners(element.no_of_owners)}}</p>
                            <p class="col-4">{{element?.year_of_manufacture}}</p>
                          </div>
                        </div>
                          <div class="d-flex col-12 text-left card-dataprice ">
                            <p class="price" *ngIf="element.dealer_suggestive_price != null">{{ 
                              element.dealer_suggestive_price > 999 
                                ? (element.dealer_suggestive_price | currency: 'INR': 'symbol': '4.0-0') 
                                : (element.dealer_suggestive_price | currency: 'INR': 'symbol': '1.0-0') 
                            }}</p><span class="warranty" *ngIf="element.engine_warranty != null">Warranty Available</span>

                            <div *ngIf="element.dealer_suggestive_price == null" style="margin-top: 10px;">
                             <span style="color:#0A0A5F;">Please contact to dealer</span>
                            </div>
                          </div>
                          <div class="col-12 btngroup">
                          <button  class="btn col-6 btn-outline-primary btn-grad-outline-primary btn-brand  " (click)="redirect(element.id)">View Details</button>
                          <button id="otpVerification"  class="btn col-6 btn-primary  btn-grad-primary btn-brand " data-bs-toggle="modal" [attr.data-bs-target]="isUserLoggedIn ? '#contactDealerFromSimilar' : '#loginDealer'" (click)="contactDealer(element.id)">Submit Enquiry</button>
                          </div>
                      </div>
                  </div>
                  </div>
                  </ng-template>
          </ng-container>
          </owl-carousel-o>
  </div>
</section>
<!-- Modal -->
<div class="modal fade" id="contactDealerFromSimilar" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
<div class="modal-dialog modal-dialog-centered">
  <div class="modal-content modaldiv">
    <div class="modal-header" style="border-bottom: none !important;">
      <h1 *ngIf="!disableForm" class="modal-title fs-5" id="exampleModalLabel">Personal Details</h1>
      <button type="button" id="closeBtn" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    </div>
    <div class="modal-body text-secondary" style="height: 100% !important;margin-top: 0px;padding-top: 0px;">
      <div *ngIf="!disableForm">
      <form [formGroup]="userFormsimilar">
      <div class="col-12">
        <label>Name </label>
            <input [ngClass]="{
              'disabled': userData?.first_name || userData?.last_name
            }" type="text" class="form-control h-48" formControlName="name" placeholder="Enter Name"
               (keydown)="notAllowSpace($event)" />
               <div *ngIf="userFormsimilar.controls['name'].invalid && (userFormsimilar.controls['name'].dirty || userFormsimilar.controls['name'].touched)">
                <div *ngIf="userFormsimilar.controls['name'].errors?.required" class="text-danger">Name is required.</div>
              </div>
      </div>
      <div class="col-12 mt-3">
        <label>Contact Info</label>
        <div class="form-input">
          <div class="country-code">
            <div class="nation-flag">
              <img alt="Nation Flag" [src]='environment1 + "assets/images/ind-flag.svg"' class="img-fluid" loading="lazy"/>
            </div>
            +91
          </div>
          <input formControlName="contact" type="tel"  class="mobile_no"
            maxlength="10" placeholder="Mobile Number" numbersOnly [ngClass]="{
              'disabled': userData?.mobile_number
            }" />
           
        </div>
        <div *ngIf="userFormsimilar.controls['contact'].invalid && (userFormsimilar.controls['contact'].dirty || userFormsimilar.controls['contact'].touched)">
          <div *ngIf="userFormsimilar.controls['contact'].errors?.required" class="text-danger">Contact number is required.</div>
          <div *ngIf="userFormsimilar.controls['contact'].errors?.pattern" class="text-danger">Contact number must be 10 digits long.</div>
        </div>
      </div>
      <div class="col-12 mt-3">
        <label>Do you need financing ? </label> 
        <div class="mt-3">
          <input id="subscription" type="radio" formControlName="consent" value="yes"> Yes
          <input id="subscription" class="ps-2" type="radio" formControlName="consent" value="no"> No
        </div>
        <div *ngIf="userFormsimilar.controls['consent'].invalid && (userFormsimilar.controls['consent'].dirty || userFormsimilar.controls['consent'].touched)">
          <div *ngIf="userFormsimilar.controls['consent'].errors?.required" class="text-danger">consent choice is required.</div>
        </div>
        <div class="form-check mt-2">
          <input class="form-check-input consent-box" type="checkbox" value="" id="defaultCheck1" #myCheckbox (change)="onCheckboxChange(myCheckbox.checked)">
          <label class="form-check-label" for="defaultCheck1">
            Consent to allow TATA Motors to contact you
          </label>
        </div>
      </div>
      <div class="col-12 mt-3">
     <button class="btn col-12 btn-primary  btn-grad-primary btn-brand h-48"  [disabled]="userFormsimilar.invalid" [ngClass]="{'disabled': !checkBoxcheked}" (click)="onSubmit()">Submit</button>
      </div>
    </form>
  </div>
  <div *ngIf="disableForm">
    <div *ngIf="errorMessage?.success">
    <div class="d-flex justify-content-center">
        <img style="height: 150px;width: 150px;margin-bottom: 20px;" [src]='environment1 + "assets/images/success.svg"' alt="">
    </div>
    <h2 class="text-center text-dark fw-bold mb-4">Congratulations!</h2>
      <h3 class="text-center text-secondary fw-bold mb-4" style="font-size: larger;">Dealer from TATA Motors will get in touch  with you soon</h3>
    <button class="btn col-12 btn-primary  btn-grad-primary btn-brand" data-bs-dismiss="modal" aria-label="Close">Back to Page</button>
  </div>
  <div *ngIf="!errorMessage?.success">
    <div class="d-flex justify-content-center">
        <img style="height: 150px;width: 150px;margin-bottom: 20px;" [src]='environment1 + "assets/images/rejected.svg"' alt="">
    </div>
    <h4 class="text-center text-dark fw-bold mb-4">There was some error while submitting.<br>Please try after some time.</h4>
    <button class="btn col-12 btn-primary  btn-grad-primary btn-brand" data-bs-dismiss="modal" aria-label="Close">Retry</button>
  </div>
  </div>
    </div>
  </div>
</div>
</div> 

<div
class="modal fade"
id="loginDealer"
tabindex="-1"
aria-labelledby="loginDealerLabel"
aria-hidden="true"
>
<div class="modal-dialog modal-dialog-centered">
  <div class="modal-content modaldiv">
    <div class="modal-header " style="border-bottom: none !important">
      <h1
        *ngIf="!disableForm"
        class="modal-title fs-5"
        id="loginDealerLabel"
      >
        Login With OTP
      </h1>
      <button
        type="button"
        id="closeBtn1"
        class="btn-close"
        data-bs-dismiss="modal"
        aria-label="Close"
        aria-hidden="true"
      ></button>
    </div>
    <div
      class="modal-body text-secondary"
      style="height: 100% !important; margin-top: 0px; padding-top: 0px"
    >
      <div *ngIf="!disableForm">
        <form [formGroup]="userLoginForm">
          <div class="col-12 mt-3">
            <label for="mobileNumber">Contact Info</label>
            <div class="form-input">
              <div class="country-code">
                <div class="nation-flag">
                  <img
                    alt="Nation Flag"
                    [src]='environment1 + "assets/images/ind-flag.svg"'
                    class="img-fluid"
                    loading="lazy"
                  />
                </div>
                +91
              </div>
              <input
                id="mobileNumber"
                formControlName="mobile_number"
                type="tel"
                class="mobile_no"
                maxlength="10"
                placeholder="Mobile Number"
                numbersOnly
                (keypress)="onlyNumberKey($event)"
                [ngClass]="{
                  'disabled': userData?.mobile_number
                }"
              />
            </div>
            <div
              *ngIf="userLoginForm.controls['mobile_number'].invalid && (userLoginForm.controls['mobile_number'].dirty || userLoginForm.controls['mobile_number'].touched)"
            >
              <div
                *ngIf="userLoginForm.controls['mobile_number'].errors?.required"
                class="text-danger"
              >
                Contact number is required.
              </div>
              <div
                *ngIf="userLoginForm.controls['mobile_number'].errors?.pattern"
                class="text-danger"
              >
                Contact number must be 10 digits long.
              </div>
            </div>
            <div class="form-check mt-2">
              <input
                class="form-check-input consent-box"
                type="checkbox"  [formControl]="checkBoxControl"
                id="defaultCheck1" 
                #myCheckbox
                (change)="onCheckboxChange(myCheckbox.checked)"
              />
              <label class="form-check-label" for="defaultCheck1">
                Consent to allow TATA Motors to contact you
              </label>
            </div>
          </div>
          <div class="col-12 mt-3">
            <button
              class="btn col-6 btn-primary btn-grad-primary btn-brand"
              data-bs-toggle="modal"
              [disabled]="userLoginForm.invalid" 
              [ngClass]="{'disabled': !checkBoxcheked}"
              data-bs-target="#showOtp"
              (click)="sentOtp()"
            >
              GET CODE
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
</div>



<div
class="modal fade"
id="showOtp"
tabindex="-1"
aria-labelledby="showOtpLabel"
aria-hidden="true" 
[hidden]="!(isshowOtp || isshowSignUp)"
>
<div class="modal-dialog modal-dialog-centered">
<div class="modal-content modaldiv" >
    <div class="close-button" style="border-bottom: none !important">
      <button
        type="button"
        id="closeBtn2"
        class="btn-close"
        data-bs-dismiss="modal"
        aria-label="Close"
      ></button>
    </div>
    <div
      class="modal-body text-secondary"
      style="height: 100% !important; margin-top: 0px; padding-top: 0px"
    >
    <section *ngIf="isshowOtp">
      <app-otp (loadParent)="showLogin()"  (loadSignup)="showSignup()"></app-otp>
    </section>
    <section *ngIf="isshowSignUp">
      <app-signup (loadParent)="showLogin()" (loadOtpParent)="showOtp()"></app-signup>
    </section>
    </div>
  </div>
  
</div>
</div>

